var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.22 49.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.61,
    cy: 24.61,
    r: 22.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 24.61,
    x2: 47.22,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.61,
    y1: 2,
    x2: 24.61,
    y2: 47.22
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.11,2s12.44,1.06,12.44,22.61-12.44,22.61-12.44,22.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.11,47.22s-12.44-1.06-12.44-22.61S25.11,2,25.11,2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.43,38.06c3.88-2.16,9.67-3.94,18.18-3.94s13.93,1.61,17.78,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.43,11.16c3.88,2.16,9.67,3.94,18.18,3.94s13.93-1.61,17.78-3.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.a19c5189.svg";
export { ForwardRef as ReactComponent };